var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"footer-content"},[_c('p',{staticClass:"company-name"},[_vm._v("MAGICUBE GROUP CO., LIMITED")]),_c('p',{staticClass:"company-address"},[_vm._v(" RM 1801 EASEY COMM BLDG 253-261 HENNESSY ROAD WANCHAI HK. ")]),_c('p',{staticClass:"copyright"},[_vm._v(" "+_vm._s(_vm.$t('copyright'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }